module.exports = __webpack_public_path__ + "media/images/icons/flags/CC-cc36acd280a4323a3183e8419690ce35.svg";